import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './podcast.component.scss';
var Podcast = /** @class */ (function (_super) {
    tslib_1.__extends(Podcast, _super);
    function Podcast(element) {
        return _super.call(this, element) || this;
    }
    Podcast.prototype.init = function () {
        if (this.element.clientWidth < 575) {
            this.element.classList.add('smaller');
        }
        if (!this.element.classList.contains('podcast__spotify')) {
            this.scriptContainer = this.element.querySelector('.podcast__script');
            this.cloned = this.element.querySelector('audio');
            this.audio = this.element.querySelector('audio');
            this.button = this.element.querySelector('.js-play-button');
            this.current = Array.from(this.element.querySelectorAll('.js-time-played'));
            this.duration = Array.from(this.element.querySelectorAll('.js-time-total'));
            this.progress = this.element.querySelector('.js-range-progress');
            this.progressDiv = this.element.querySelector('.podcast__player--buffer__progress--filled');
            this.volume = this.element.querySelector('.js-range-volume');
            this.volumeButton = this.element.querySelector('.js-volume-button');
            this.volumeDiv = this.element.querySelector('.podcast__player--volume__progress--filled');
            this.volumeDivThumb = this.element.querySelector('.podcast__player--volume__progress--button');
            this.valueStoredVolume = 0.5;
            this.volume.value = 0.5;
            this.volumeDiv.style.width = 50 + "%";
            this.volumeDivThumb.style.left = 50 + "%";
            this.createCustomAudioPlayer();
        }
    };
    Podcast.prototype.bindEvents = function () {
        var _this = this;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (this.button) {
            this.button.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                if (element.classList.contains('playing')) {
                    element.classList.remove('playing');
                    _this.pauseAudio();
                }
                else {
                    element.classList.add('playing');
                    _this.playAudio();
                }
            });
        }
        if (this.progress) {
            if (msie > 0) {
                this.progress.addEventListener('change', function (event) {
                    _this.changeProgress(event);
                });
            }
            else {
                this.progress.addEventListener('input', function (event) {
                    _this.changeProgress(event);
                });
            }
        }
        if (this.volume) {
            if (msie > 0) {
                this.volume.addEventListener('change', function (event) {
                    _this.changeVolume(event);
                });
            }
            else {
                this.volume.addEventListener('input', function (event) {
                    _this.changeVolume(event);
                });
            }
        }
        if (this.volumeButton) {
            this.volumeButton.addEventListener('click', function (event) {
                _this.muteClick(event);
            });
        }
    };
    Podcast.prototype.playAudio = function () {
        if (this.audio) {
            this.audio.play();
        }
    };
    Podcast.prototype.pauseAudio = function () {
        if (this.audio) {
            this.audio.pause();
        }
    };
    Podcast.prototype.createCustomAudioPlayer = function () {
        var _this = this;
        if (this.cloned) {
            var source = Array.from(this.cloned.querySelectorAll('source'));
            var theDuration_1 = 0;
            var newAudio = new Audio();
            newAudio.id = "new_audio";
            newAudio.controls = true;
            newAudio.autoplay = false;
            newAudio.setAttribute('x-webkit-airplay', true);
            var newSourceMpeg = document.createElement('source');
            newSourceMpeg.src = window.location.protocol + "//" + window.location.host + source[0].getAttribute('src');
            newSourceMpeg.type = "audio/mpeg";
            newAudio.appendChild(newSourceMpeg);
            var newSourceWav = document.createElement('source');
            newSourceWav.src = window.location.protocol + "//" + window.location.host + source[0].getAttribute('src');
            newSourceWav.type = "audio/wav";
            newAudio.appendChild(newSourceWav);
            this.audio = newAudio;
            this.audio.addEventListener('loadedmetadata', function () {
                theDuration_1 = Math.ceil(_this.audio.duration);
                var minutes = "0" + Math.floor(theDuration_1 / 60);
                var seconds = "0" + (theDuration_1 - minutes * 60);
                _this.duration.map(function (item) {
                    item.innerHTML = minutes.substr(-2) + ":" + seconds.substr(-2);
                });
                _this.progress.setAttribute('max', theDuration_1);
            });
            this.audio.addEventListener('timeupdate', function () {
                var curTime = _this.audio.currentTime;
                _this.progress.value = curTime;
                _this.progressDiv.style.width = 100 / _this.audio.duration * curTime + "%";
                var formattedTime = parseInt(_this.audio.currentTime, 10);
                var minutes = "0" + Math.floor(formattedTime / 60);
                var seconds = "0" + (formattedTime - minutes * 60);
                _this.current.map(function (item) {
                    item.innerHTML = minutes.substr(-2) + ":" + seconds.substr(-2);
                });
            });
            this.audio.addEventListener('ended', function () {
                _this.progress.value = 0;
                _this.current.innerHTML = "00:00";
                _this.button.classList.remove('playing');
                _this.progressDiv.style.width = "0%";
            });
        }
    };
    Podcast.prototype.changeProgress = function (event) {
        if (event === void 0) { event = ''; }
        if (event) {
            this.audio.pause();
            this.button.classList.remove('playing');
            var element = void 0;
            element = event.target;
            this.audio.currentTime = element.value;
            this.progressDiv.style.width = 100 / this.audio.duration * this.audio.currentTime + "%";
        }
    };
    Podcast.prototype.changeVolume = function (event) {
        if (event === void 0) { event = ''; }
        if (event) {
            var element = void 0;
            element = event.target;
            this.audio.volume = element.value;
            this.valueStoredVolume = element.value;
            this.volumeDiv.style.width = this.valueStoredVolume * 100 + "%";
            this.volumeDivThumb.style.left = this.valueStoredVolume * 100 + "%";
            if (this.valueStoredVolume == 0) {
                this.volumeButton.classList.add('muted');
            }
            else {
                this.volumeButton.classList.remove('muted');
            }
        }
    };
    Podcast.prototype.muteClick = function (event) {
        if (event === void 0) { event = ''; }
        if (event) {
            var element = void 0;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            if (element.classList.contains('muted')) {
                element.classList.remove('muted');
                if (this.valueStoredVolume == 0) {
                    this.audio.volume = 0.5;
                    this.volume.value = 0.5;
                    this.valueStoredVolume = 0.5;
                    this.volumeDiv.style.width = 0.5 * 100 + "%";
                    this.volumeDivThumb.style.left = 0.5 * 100 + "%";
                }
                else {
                    this.audio.volume = this.valueStoredVolume;
                    this.volume.value = this.valueStoredVolume;
                    this.volumeDiv.style.width = this.valueStoredVolume * 100 + "%";
                    this.volumeDivThumb.style.left = this.valueStoredVolume * 100 + "%";
                }
            }
            else {
                element.classList.add('muted');
                this.audio.volume = 0.0;
                this.volume.value = 0.0;
                this.volumeDiv.style.width = 0 + "%";
                this.volumeDivThumb.style.left = 0 + "%";
            }
        }
    };
    return Podcast;
}(Base));
export { Podcast };



//////////////////
// WEBPACK FOOTER
// ./components/podcast/podcast.component.ts
// module id = 434
// module chunks = 0